/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react'

import i18n from 'live/services/i18n'

import { ReportFilterToRequisition } from './ReportFilterToRequisition'
import { ConfigHeaderFilterContainer, ConfigHeaderFilterDropdown } from './style'

interface IProps {
    buttonTitle: string
    filter?: Set<string>
    setFilter?: (k: Set<string>) => void
    list?: Set<string>
    setList?: (k: Set<string>) => void
    search?: string
    setSearch?: (k: string) => void
    field?: string
    order?: IOrder
    setOrder?: (k: IOrder) => void
    last?: boolean
    onClearAll: number
}

interface IOrder {
    field: string
    order: boolean
}

export const ReportPopover: React.FC<IProps> = ({
    buttonTitle,
    list,
    order,
    search,
    field,
    filter,
    setFilter,
    setList,
    setOrder,
    setSearch,
    last,
    onClearAll
}) => {
    const [show, setShow] = React.useState<boolean>(false)
    const dropdownRef = React.useRef<HTMLDivElement>(null)

    React.useEffect(() => {
        function handleMouseDownAction(this: Document, ev: MouseEvent): void {
            if (
                dropdownRef.current &&
                !dropdownRef.current.contains(ev.target as HTMLElement) &&
                !(ev.target as HTMLElement).className.includes('Select-option')
            ) {
                setShow(false)
            }
        }

        document.addEventListener('mousedown', handleMouseDownAction)

        return () => {
            document.removeEventListener('mousedown', handleMouseDownAction)
        }
    }, [])

    return (
        <ConfigHeaderFilterContainer active={show} ref={dropdownRef}>
            <div
                className="configheaderfilter-clickable"
                id="systemAudit-configHeaderFilter-clickable"
                onClick={() => {
                    setShow(old => !old)
                }}
            >
                {i18n(buttonTitle)}
                {filter.size > 0 ? <i className="fas fa-filter"></i> : <i className="far fa-filter"></i>}
            </div>

            <ConfigHeaderFilterDropdown last={last} style={{ visibility: show ? 'visible' : 'hidden' }}>
                <ReportFilterToRequisition
                    search={search}
                    setSearch={setSearch}
                    order={order}
                    setOrder={setOrder}
                    field={field}
                    list={list}
                    setList={setList}
                    setFilter={setFilter}
                    filter={filter}
                    onClearAll={onClearAll}
                />
            </ConfigHeaderFilterDropdown>
        </ConfigHeaderFilterContainer>
    )
}
